import { Button, CardMedia, Paper, Typography } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'
import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { rutas } from '../../rutas/rutas'
import { getCookie } from '../../utils/getCookie'
import fondo from '../../Web Mundo/Fondo_new_islas_lhtanv.png'

import axios from 'axios';
import { v4 as uuidv4 } from "uuid";
import { setInformacion } from '../../storage/slices/usuarios';

export const Inventario = () => {
    const {informacion} = useSelector(state=> state.userSlice)
    const [open, setOpen] = useState(false);
    const [open2, setOpen2] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const dispatch = useDispatch()
    const [articulos, setArticulos ] = useState(informacion?.inventario)
    const [sobresAbierto, setSobresAbierto] = useState([]);
    const abrirSobres = (nombre) => {
      const tokenJWT = getCookie("token");
      const ruta = nombre.includes('ticket') ?  rutas.abrirTicket : rutas.abrirPack
    
      axios
        .post(
          ruta,
          { pack: nombre, user: informacion.nombre },
          { headers: { token: tokenJWT } }
        )
        .then((res) => {
      
          if (Array.isArray(res.data?.carta)) {
            axios.get(`${rutas.getInformacion}`, { headers: {'token': tokenJWT}})
            .then(res=> {
              setArticulos(res.data?.resultado?.inventario)
                dispatch(setInformacion({...res.data?.resultado}));
            
            })
            setSobresAbierto(res.data.carta);
            handleOpen();
          }
        })
        .catch((err) => console.error(err));
    };
    const style = {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: { xs: 350, sm: "80%", md: "70%", lg: "60%", xl: "40%" },
      height: sobresAbierto.length < 4 ? "250px" : "450px",
      background: "#222730",
      border: "1px solid #000",
      opacity: 0.1,
      p: 4,
    };
    
  return (
    <Box sx={{backgroundImage: `url(${fondo})`, display:'flex', justifyContent:'center',alignItems: 'center', width: '100%', height: '95vh', backgroundPosition: 'bottom', backgroundSize: 'cover'}}>
    <Paper sx={{flexWrap: 'wrap',justifyContent:'start',alignItems: 'start',  display:'flex', backgroundColor: 'rgba(255, 255, 255, 0.1)',width: '90%', height: '100%'}}>{articulos?.length > 0  ? articulos.map(item=> <Box      sx={{ flexDirection: 'column',display:'flex', justifyContent:'center', alignItems:'center',width: '220px', height: '300px', m:1}} key={item?.nombre}>
        <CardMedia
        component="img"
        sx={{ width: '90%', height:'240px !important'}}
        image={item?.image}
        alt="P"
      />
      <Typography>{item?.nombre + ' - '+ item?.cantidad}</Typography>
      <Button disabled={item?.nombre.includes('Fusion')} onClick={()=>!item?.nombre.includes('Fusion') && abrirSobres(item?.nombre)}   sx={{ width: '140px'}} variant='contained'>Open</Button>
    </Box>) : null}</Paper>


    <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open}>
            <Box sx={style}>
              <Box
                sx={{
                  width: "100%",
                  height: "100%",
                  border: "1px solid gray",
                  display: "flex",
                  flexWrap: "wrap",
                  overflow: "auto",
                  justifyContent: sobresAbierto.length < 4 ? "center" : "",
                  alingItems: sobresAbierto.length < 4 ? "center" : "",
                  "&::-webkit-scrollbar": {
                    display: "none",
                  },
                }}
              >
                {sobresAbierto.map((card) => {
                  return (
                    <Box
                      sx={{
                        width: {
                          xs: "85px",
                          sm: sobresAbierto.length < 4 ? "150px" : "120px",
                        },
                        height: {
                          xs: "120px",
                          sm: sobresAbierto.length < 4 ? "220px" : "150px",
                        },
                        position: "relative",
                        margin: "5px",
                      }}
                      key={uuidv4()}
                      draggable="false"
                      className="animate__animated animate__fadeInUp"
                    >
                      <CardMedia
                        component="img"
                        image={card?.url}
                        alt="Inicial"
                        sx={{
                          cursor: "pointer",
                          width: {
                            xs: "85px",
                            sm: sobresAbierto.length < 4 ? "150px" : "120px",
                          },
                          height: {
                            xs: "120px",
                            sm: sobresAbierto.length < 10 ? "220px" : "150px",
                          },
                          boxShadow: card?.brillante
                            ? "0px 0px 10px yellow"
                            : "none",
                          objectFit: "fill",
                        }}
                        onClick={() => {
                          //   setSelector(card);
                          //   setOpen2(true);
                        }}
                      />
                      {card?.item && (
                        <Box
                          sx={{
                            position: "absolute",
                            top: "0",
                            left: "0",
                            background: 'rgba(0, 0, 0,0.5)',
                            width: "80px",
                            height: "35px",
                            borderRadius: "50%",
                            textAlign: "center",
                            color: "white",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {card?.item}
                        </Box>
                      )}
                      {card?.rareza && (
                        <Box
                          sx={{
                            position: "absolute",
                            top: "0",
                            right: "0",
                            background: 'gray',
                            width: "20px",
                            height: "20px",
                            borderRadius: "50%",
                            textAlign: "center",
                            color: "white",
                          }}
                        >
                          {card?.rareza}
                        </Box>
                      )}
                      {card?.cantidad && (
                        <Box
                          sx={{
                            position: "absolute",
                            top: "0",
                            left: "0",
                            width: "20px",
                            height: "20px",
                            borderRadius: "50%",
                            textAlign: "center",
                            color: "white",
                          }}
                        >
                          {card?.cantidad}
                        </Box>
                      )}
                    </Box>
                  );
                })}
              </Box>
              <Typography
                id="transition-modal-title"
                variant="h6"
                component="h2"
              ></Typography>
            </Box>
          </Fade>
        </Modal>
</Box>

  )
}
